import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatDate } from "@/lib/format";
import type { DBProject } from "@/lib/db-types";
import type { UserLookup } from "@/hooks/use-users";
import { InfoRow } from "./BudgetTab";

interface DetaljerTabProps {
  project: DBProject;
  customer: any;
  allUsers: UserLookup[];
}

export function DetaljerTab({ project: p, customer, allUsers }: DetaljerTabProps) {
  const projectLead = p.production_lead_id ? allUsers.find((u) => u.id === p.production_lead_id) : null;
  const advisor = p.advisor_id ? allUsers.find(u => u.id === p.advisor_id) : null;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Prosjektinfo */}
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Prosjektinfo</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3 text-sm">
            <InfoRow label="Prosjektkode" value={p.project_code} />
            <InfoRow label="Kunde" value={customer?.name} />
            <InfoRow label="Kontaktperson" value={customer?.contact_person} />
            <InfoRow label="E-post" value={customer?.contact_email} />
            {/*
              VIB-2521: faktura-e-post er et ANNET PO-felt enn kontakt-e-posten
              over. Setter vi ikke projects.invoice_email, sender PO fakturaen
              hit. Vises derfor eksplisitt, så PL-en ikke retter «E-post» i den
              tro at det styrer hvor fakturaen havner.
            */}
            <InfoRow label="Faktura-e-post" value={customer?.invoice_email_address} />
            <InfoRow label="Org.nr" value={customer?.organization_number} />
            <InfoRow
              label="Kunderådgiver"
              value={advisor?.full_name ?? null}
            />
            <InfoRow
              label="Prosjektleder"
              value={projectLead?.full_name ?? null}
            />
            <InfoRow label="Est. slutt faktura" value={formatDate(p.estimated_deadline)} />
            <InfoRow label="Estimert oppstart" value={formatDate(p.estimated_start_date)} />
            <InfoRow label="Intern" value={p.is_internal ? "Ja" : "Nei"} />
          </CardContent>
        </Card>

      </div>
    </div>
  );
}
